<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :dense="dense"
            :multiple="multiple"
            :autoComplete="autoComplete"
            :disabled="disabled"
            :outlined="outlined"
            :itemText="itemText"
            :hideDetails="hideDetails"
            :class="classe"
            :classe="classe"
            @change="$emit('change', $event)"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectOfferItemCourse',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showInactive: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
        itemText: {

        }
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
       
    },
    methods: {
        ...mapActions('grid', ['ActionIndexOfferItemCourses']),    
        
        async loadData(filter) {

            this.loading = true;

            await this.ActionIndexOfferItemCourses(filter)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>